import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { linkCampanaGuard } from './shared/guards/link-campana.guard';

const routes: Routes = [
  {
    path: 'denounce',
    loadChildren: () =>
      import('./denounce-public/denounce-public.module').then(
        (m) => m.DenouncePublicModule,
      ),
  },
  {
    // Registro público de pagador por link (sin guard).
    path: 'pagador-registro/:shortCode',
    loadChildren: () =>
      import('./pagador-registro/pagador-registro.module').then(
        (m) => m.PagadorRegistroModule,
      ),
  },
  {
    // Misma pantalla con una dirección sin la palabra "pagador": es la que
    // generan los links nuevos. La de arriba sigue viva para los ya enviados.
    path: 'registro/:shortCode',
    loadChildren: () =>
      import('./pagador-registro/pagador-registro.module').then(
        (m) => m.PagadorRegistroModule,
      ),
  },
  {
    // Link corto de campana de Marketing: /r/redes → registro con ?origen=redes.
    path: 'r/:codigo',
    canActivate: [linkCampanaGuard],
    children: [],
  },
  {
    path: 'maintenance-global',
    loadComponent: () =>
      import(
        './shared/pages/maintenance-global/maintenance-global.component'
      ).then((m) => m.MaintenanceGlobalComponent),
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./shared/pages/not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
    data: { reason: 'unauthorized' },
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/pages/not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
